import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import format from 'date-fns/format'
import _ from 'lodash'
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days'
import {globalfunc} from '../globalfunc.js'
import { getTeamByCompany, getUserAll } from './core/cacheService'
export default {
    namespaced: true,
    state: {
      teams:[],
      teamsall:[],
      inputSearch: '',
      page:1,
      size_page:10,
      results: 0,
      sortBy: 'name',
      teamDuplicate: [],
      organizations: [],
      loadingTeamsTable: true,
      teamRandomNumber: '',
    },
    mutations: {
        setTeams(state:any, result:any) {
            state.teams = result
        },
        setTeamsAll(state:any, result:any) {
            state.teamsall = result
        },
        setinputSearch(state:any,value:any) {
            state.inputSearch = value.value
        },
        setPage(state:any,result:any) {
            state.page = result
        },
        setResults(state:any, result:any) {
            state.results = result
        },
        setTeamDuplicate(state:any, result:any) {
            state.teamDuplicate = result
        },
        setOrganizations(state: any, value: any) {
            state.organizations = value
        },
        setLoadingTeamsTable(state:any, result:any) {
            state.loadingTeamsTable = result
        },
        setTeamRandomNumber(state: any, value: any) {
            state.teamRandomNumber = value
        },
    },
    actions: {
        getTeamsOptions({dispatch,state}:any, user:any){
            if(state.teamsall.length ==0){
                dispatch('getTeams',user)
            }
        },
        getOrganization({ commit,state, rootState }: any) {
            if(state.organizations.length == 0){
              firebase.firestore().collection('organization').where("company", "==", rootState.authen.user.company).get()
              .then(function (querySnapshot) {
                const organizations: Array<any> = [];
                querySnapshot.forEach((doc) => {
                  const organization = doc.data()
                  organization.key = doc.id
                  organizations[organization.team_id] = organization
                });
                commit('setOrganizations', organizations)
              });
            }
        },
        async generateTeamRandomNumber({commit,dispatch,state,rootState}:any){
            let text = "t"+globalfunc.generateRandomNumber()
            firebase.database().ref('team').orderByChild("internal_id").equalTo(`${text}`).once('value', snapshot => {
                const teamCheck:Array<any> = [];
                snapshot.forEach((arrData):any => {
                    const u = arrData.val()
                    teamCheck.push(u)
                });
                if(teamCheck.length == 0){
                    commit('setTeamRandomNumber', text)
                }else{
                    dispatch('generateTeamRandomNumber')
                }
            })
        },
        async getTeams({commit,dispatch,state,rootState}:any, user:any){
            commit('setLoadingTeamsTable',true)
            commit('setTeams',[])
            let dateNow = new Date()
            const checkTeam:Array<any> = []
            let team_duplicate:Array<any> = []
            team_duplicate['status'] = false
            team_duplicate['count'] = 0
            const supUserByTeam:Array<any> = []
            let userData:Array<any> = [];
            let teamIn:Array<any> = []
            let noDup = 0
            const allBoss:Array<any> = (await firebase.database().ref(`boss/${user.company}`).once('value')).val()
            const team = await getTeamByCompany(user.company)//(await firebase.database().ref('team').orderByChild("company").equalTo(user.company).once('value')).val()
            const allUser = await getUserAll(user.company)//(await firebase.database().ref('users').orderByChild("company").equalTo(user.company).once('value')).val()
            for(const arrData in allUser){
                const u = allUser[arrData]
                u.key = arrData
                if(u.team) u.team_name = (team[u.team]!=undefined)?team[u.team]["name"]:''
                if(u.profilepic_small){
                    u.pic = u.profilepic_small;
                  }else if (u.profilepic_crop){
                    u.pic = u.profilepic_crop;
                  }else if (u.profilepic){
                    u.pic = u.profilepic;
                  }else {
                    u.pic = "";
                  }
                if(u.tutorial && u.tutorial == 'Y'){
                let dayActive = differenceInCalendarDays(dateNow, u.updated)
                if(dayActive > 30){
                    u.status = 'inactive'
                    u.to_now = format(u.updated,'MMM D, YYYY')
                }else{
                    u.status = 'active'
                    u.to_now = globalfunc.timeSince(u.updated)
                }
                }else if(u.invited){
                    u.status = 'invited'
                    u.to_now = globalfunc.timeSince(u.updated)
                }else{
                    u.status = 'new'
                }
                let k_boss = allUser[arrData].boss.replace(/\./g, "||")
                if(k_boss && allUser[k_boss] != undefined){
                    u.boss_firstname = allUser[k_boss]["firstname"]
                    u.boss_lastname = allUser[k_boss]["lastname"]
                }
                if(supUserByTeam[u.team] === undefined){
                    supUserByTeam[u.team] = new Array()
                }
                supUserByTeam[u.team].push(u)
                userData[u.email] = u
            }
            try{
                const teamData=await getTeamByCompany(user.company)
                const teams:Array<any> = [];
                const parent:Array<any> = [];
                for(const key in teamData){
                    const team = teamData[key]
                    team.key =key
                    team.value = teamData[key].name
                    if(teamData[key].goals){
                        console.log('teamData[key].goals', teamData[key].goals);
                    }
                    team.team_goals = teamData[key].goals
                    if(team.sup === undefined){
                        team.sup = new Array()
                    }
                    if(checkTeam["check_"+team.name.toLowerCase()]){
                        team_duplicate['status'] = true
                        team_duplicate['count'] += 2
                        team.duplicate = true
                        team.duporder = noDup
                        noDup++
                        const teamKey = _.findKey(teams, ['name', checkTeam["check_"+team.name.toLowerCase()]])
                        if(teamKey){
                            teams[teamKey].duplicate = true
                            teams[teamKey].duporder = noDup
                            noDup++
                        }
                    }
                    checkTeam["check_"+team.name.toLowerCase()] = team.name
                    // team.sup = supUserByTeam[team.key]
                    let teamId = team.key
                    let arrTeam = state.organizations[teamId];
                    if(arrTeam){
                        if (arrTeam.parent) {
                            if (teamIn[teamId] === undefined) {
                                teamIn[teamId] = new Array();
                            }
                            teamIn[teamId][teamId] = true;
                            teamIn[teamId] = globalfunc.getTeamOfParent(arrTeam.parent,teamIn[teamId]);
                            for (const k in teamIn[teamId]) {
                                const userTeam = supUserByTeam[k]
                                for (const x in userTeam) {
                                    team.sup = _.concat(team.sup, userData[userTeam[x].email]);
                                }
                            }
                        }
                    }else{
                        const userTeam = supUserByTeam[teamId]
                        for (const x in userTeam) {
                            team.sup = _.concat(team.sup, userData[userTeam[x].email]);
                        }
                    }
                    team.sup = _.sortBy(team.sup, [function(o:any) { return o.firstname; }])
                    if(team.members === undefined){
                        team.members = new Array()
                    }
                    team.members = _.filter(allUser, { team: team.key });
                    if(team.members.length > 0){
                        let email = ""
                        if(team.members.length == 1){
                            let directReport = new Array()
                            directReport = _.filter(allUser, { boss: team.members[0].email });
                            if(directReport.length > 0){
                                email = team.members[0].email.replace(/\./g, "||")
                            }else{
                                if(team.members[0].boss){
                                    email = team.members[0].boss.replace(/\./g, "||")
                                }
                            }
                        }else {
                            let teamManager:Array<any> = [];
                            let bossInTeam:Array<any> = [];
                            for(const i in team.members){
                                let directReport = new Array()
                                directReport = _.filter(allUser, { boss: team.members[i].email });
                                if(directReport.length > 0){
                                    teamManager.push(team.members[i].email)
                                }
                                if(team.members[i].boss){
                                    bossInTeam[team.members[i].boss] = team.members[i].boss
                                }
                            }
                            if(teamManager.length == 0){
                                if(bossInTeam && Object.keys(bossInTeam).length == 1){
                                    email = bossInTeam[Object.keys(bossInTeam)[0]].replace(/\./g, "||")
                                }else if(bossInTeam && Object.keys(bossInTeam).length > 1){
                                    email = 'multiple'
                                }
                            }else if(teamManager.length == 1){
                                email = teamManager[0].replace(/\./g, "||")
                            }else{
                                email = 'multiple'
                            }
                        }
                        
                        if (email == 'multiple'){
                            team.multiple = true
                        }else if(email && allUser[email]){
                            team.boss_firstname = allUser[email].firstname
                            team.boss_lastname = allUser[email].lastname
                            if(allUser[email].profilepic_small){
                                team.pic = allUser[email].profilepic_small;
                            }else if (allUser[email].profilepic_crop){
                                team.pic = allUser[email].profilepic_crop;
                            }else if (allUser[email].profilepic){
                                team.pic = allUser[email].profilepic;
                            }else {
                                team.pic = '';
                            }
                        }else{
                            team.boss_firstname = ''
                            team.boss_lastname = ''
                            team.pic = ''
                        }
                    }else{
                        team.boss_firstname = ''
                        team.boss_lastname = ''
                        team.pic = ''
                    }
                    
                    teams.push(team)
                    if(key) parent[key] = teamData[key]
                }



                _.forEach(teams, (value,key)=> {
                    if(value.parent && parent[value.parent]){
                        teams[key].parent_name = parent[value.parent].name
                        if(parent[value.parent].color){
                            teams[key].parent_color = parent[value.parent].color
                        }else{
                            teams[key].parent_color = ''
                        }
                    }else{
                        teams[key].parent_name = ''
                        teams[key].parent_color = ''
                    }
                });
                var _teams = _.sortBy(teams, [function(o:any) { return o.duporder; }, function(o:any) { return o.name; }])
                commit('setResults',_teams.length)
                commit('setTeamDuplicate',team_duplicate)
                commit('setTeams', _teams.slice(0, state.size_page))
                commit('setTeamsAll', _teams)
                commit('setLoadingTeamsTable',false)
                if(state.inputSearch){
                    dispatch('searchTeams',state.inputSearch)
                }
              
            }catch(error){
              console.log(error)
            }
            // await firebase.database().ref().child('users').orderByChild('company').equalTo(`${user.company}`).once('value',async snapshot => {
            //     snapshot.forEach((arrData):any => {
            //         const u = arrData.val()
            //         u.key = arrData.key
            //         if(u.team) u.team_name = (team[u.team]!=undefined)?team[u.team]["name"]:''
            //         if(u.profilepic_small){
            //             u.pic = u.profilepic_small;
            //           }else if (u.profilepic_crop){
            //             u.pic = u.profilepic_crop;
            //           }else if (u.profilepic){
            //             u.pic = u.profilepic;
            //           }else {
            //             u.pic = "";
            //           }
            //         if(u.tutorial && u.tutorial == 'Y'){
            //         let dayActive = differenceInCalendarDays(dateNow, u.updated)
            //         if(dayActive > 30){
            //             u.status = 'inactive'
            //             u.to_now = format(u.updated,'MMM D, YYYY')
            //         }else{
            //             u.status = 'active'
            //             u.to_now = globalfunc.timeSince(u.updated)
            //         }
            //         }else if(u.invited){
            //             u.status = 'invited'
            //             u.to_now = globalfunc.timeSince(u.updated)
            //         }else{
            //             u.status = 'new'
            //         }
            //         let k_boss = arrData.val().boss.replace(/\./g, "||")
            //         if(k_boss && allUser[k_boss] != undefined){
            //             u.boss_firstname = allUser[k_boss]["firstname"]
            //             u.boss_lastname = allUser[k_boss]["lastname"]
            //         }
            //         if(supUserByTeam[u.team] === undefined){
            //             supUserByTeam[u.team] = new Array()
            //         }
            //         supUserByTeam[u.team].push(u)
            //         userData[u.email] = u
            //     });
            // });

            //team old
            // firebase.database().ref().child('team').orderByChild('company').equalTo(`${user.company}`).once('value', snapshot => {
            //     const teams:Array<any> = [];
            //     const parent:Array<any> = [];
            //     snapshot.forEach((doc):any => {
            //         const team = doc.val()
            //         team.key = doc.key
            //         team.value = doc.val().name
            //         if(team.sup === undefined){
            //             team.sup = new Array()
            //         }
            //         if(checkTeam["check_"+team.name.toLowerCase()]){
            //             team_duplicate['status'] = true
            //             team_duplicate['count'] += 2
            //             team.duplicate = true
            //             team.duporder = noDup
            //             noDup++
            //             const teamKey = _.findKey(teams, ['name', checkTeam["check_"+team.name.toLowerCase()]])
            //             if(teamKey){
            //                 teams[teamKey].duplicate = true
            //                 teams[teamKey].duporder = noDup
            //                 noDup++
            //             }
            //         }
            //         checkTeam["check_"+team.name.toLowerCase()] = team.name
            //         // team.sup = supUserByTeam[team.key]
            //         let teamId = team.key
            //         let arrTeam = state.organizations[teamId];
            //         if(arrTeam){
            //             if (arrTeam.parent) {
            //                 if (teamIn[teamId] === undefined) {
            //                     teamIn[teamId] = new Array();
            //                 }
            //                 teamIn[teamId][teamId] = true;
            //                 teamIn[teamId] = globalfunc.getTeamOfParent(arrTeam.parent,teamIn[teamId]);
            //                 for (const k in teamIn[teamId]) {
            //                     const userTeam = supUserByTeam[k]
            //                     for (const x in userTeam) {
            //                         team.sup = _.concat(team.sup, userData[userTeam[x].email]);
            //                     }
            //                 }
            //             }
            //         }else{
            //             const userTeam = supUserByTeam[teamId]
            //             for (const x in userTeam) {
            //                 team.sup = _.concat(team.sup, userData[userTeam[x].email]);
            //             }
            //         }
            //         team.sup = _.sortBy(team.sup, [function(o:any) { return o.firstname; }])
            //         if(team.members === undefined){
            //             team.members = new Array()
            //         }
            //         team.members = _.filter(allUser, { team: team.key });
            //         if(team.members.length > 0){
            //             let email = ""
            //             if(team.members.length == 1){
            //                 let directReport = new Array()
            //                 directReport = _.filter(allUser, { boss: team.members[0].email });
            //                 if(directReport.length > 0){
            //                     email = team.members[0].email.replace(/\./g, "||")
            //                 }else{
            //                     if(team.members[0].boss){
            //                         email = team.members[0].boss.replace(/\./g, "||")
            //                     }
            //                 }
            //             }else {
            //                 let teamManager:Array<any> = [];
            //                 let bossInTeam:Array<any> = [];
            //                 for(const i in team.members){
            //                     let directReport = new Array()
            //                     directReport = _.filter(allUser, { boss: team.members[i].email });
            //                     if(directReport.length > 0){
            //                         teamManager.push(team.members[i].email)
            //                     }
            //                     if(team.members[i].boss){
            //                         bossInTeam[team.members[i].boss] = team.members[i].boss
            //                     }
            //                 }
            //                 if(teamManager.length == 0){
            //                     if(bossInTeam && Object.keys(bossInTeam).length == 1){
            //                         email = bossInTeam[Object.keys(bossInTeam)[0]].replace(/\./g, "||")
            //                     }else if(bossInTeam && Object.keys(bossInTeam).length > 1){
            //                         email = 'multiple'
            //                     }
            //                 }else if(teamManager.length == 1){
            //                     email = teamManager[0].replace(/\./g, "||")
            //                 }else{
            //                     email = 'multiple'
            //                 }
            //             }
                        
            //             if (email == 'multiple'){
            //                 team.multiple = true
            //             }else if(email && allUser[email]){
            //                 team.boss_firstname = allUser[email].firstname
            //                 team.boss_lastname = allUser[email].lastname
            //                 if(allUser[email].profilepic_small){
            //                     team.pic = allUser[email].profilepic_small;
            //                 }else if (allUser[email].profilepic_crop){
            //                     team.pic = allUser[email].profilepic_crop;
            //                 }else if (allUser[email].profilepic){
            //                     team.pic = allUser[email].profilepic;
            //                 }else {
            //                     team.pic = '';
            //                 }
            //             }else{
            //                 team.boss_firstname = ''
            //                 team.boss_lastname = ''
            //                 team.pic = ''
            //             }
            //         }else{
            //             team.boss_firstname = ''
            //             team.boss_lastname = ''
            //             team.pic = ''
            //         }
                    
            //         // if(team.members.length > 0){
            //         //     let email = ""
            //         //     if(team.members.length == 1){
            //         //         email = team.members[0].email.replace(/\./g, "||")
            //         //     }else {
            //         //         let innerTeam:Array<any> = [];
            //         //         let outerTeam:Array<any> = [];
            //         //         for(const i in team.members){
            //         //             let mailBoss = (team.members[i].boss) ? team.members[i].boss : ''
            //         //             let mailBossKey = (mailBoss) ? mailBoss.replace(/\./g, "||") : ''
            //         //             if(mailBoss){
            //         //                 let checkBossInTeam = _.find(team.members, { email: mailBoss });
            //         //                 if(checkBossInTeam){
            //         //                     innerTeam[mailBoss] = mailBossKey
            //         //                 }else{
            //         //                     let checkBossInTeam2 = _.filter(team.members, { boss: team.members[i].email });
            //         //                     if(checkBossInTeam2.length == 0){
            //         //                         outerTeam[mailBoss] = mailBossKey
            //         //                     }
            //         //                 }
            //         //             }
            //         //         }
            //         //         if(Object.keys(innerTeam).length > 0){
            //         //             if(Object.keys(innerTeam).length == 1 && Object.keys(outerTeam).length == 0){
            //         //                 email = innerTeam[Object.keys(innerTeam)[0]]
            //         //             }else{
            //         //                 email = 'multiple'
            //         //             }
            //         //         }else{
            //         //             if(Object.keys(outerTeam).length == 1){
            //         //                 email = outerTeam[Object.keys(outerTeam)[0]]
            //         //             }else{
            //         //                 email = 'multiple'
            //         //             }
            //         //         }
            //         //     }
            //         //     if (email == 'multiple'){
            //         //         team.multiple = true
            //         //     }else if(email && allUser[email]){
            //         //         team.boss_firstname = allUser[email].firstname
            //         //         team.boss_lastname = allUser[email].lastname
            //         //         if(allUser[email].profilepic_small){
            //         //             team.pic = allUser[email].profilepic_small;
            //         //         }else if (allUser[email].profilepic_crop){
            //         //             team.pic = allUser[email].profilepic_crop;
            //         //         }else if (allUser[email].profilepic){
            //         //             team.pic = allUser[email].profilepic;
            //         //         }else {
            //         //             team.pic = '';
            //         //         }
            //         //     }else{
            //         //         team.boss_firstname = ''
            //         //         team.boss_lastname = ''
            //         //         team.pic = ''
            //         //     }
            //         // }else{
            //         //     if(team.sup.length > 0){
            //         //         let email = ""
            //         //         if(team.sup.length == 1){
            //         //             email = team.sup[0].email.replace(/\./g, "||")
            //         //         }else {
            //         //             let checkInMultipleTeam: any = _.filter(team.sup, { 'team': team.key })
            //         //             if(checkInMultipleTeam.length == 1){
            //         //                 email = checkInMultipleTeam[0].email.replace(/\./g, "||")
            //         //             }else{
            //         //                 let arrManager:Array<any> = [];
            //         //                 for(const i in team.sup){
            //         //                     let mailBoss = team.sup[i].email.replace(/\./g, "||")
            //         //                     if(allUser[mailBoss].boss){
            //         //                         arrManager[allUser[mailBoss].boss] = allUser[mailBoss].boss
            //         //                     }
            //         //                 }

            //         //                 let boss0 = (arrManager && Object.keys(arrManager)[0]) ? arrManager[Object.keys(arrManager)[0]].replace(/\./g, "||") : ''
            //         //                 let boss1 = (arrManager && Object.keys(arrManager)[1]) ? arrManager[Object.keys(arrManager)[1]].replace(/\./g, "||") : ''
            //         //                 if(Object.keys(arrManager).length == 1){
            //         //                     email = boss0
            //         //                 }else if(Object.keys(arrManager).length == 2 && ((allUser[boss0] && allUser[boss0].boss && allUser[boss0].boss == arrManager[Object.keys(arrManager)[1]]) || (allUser[boss1] && allUser[boss1].boss && allUser[boss1].boss == arrManager[Object.keys(arrManager)[0]]))){
            //         //                     if(allUser[boss0].boss == arrManager[Object.keys(arrManager)[1]] && (allUser[boss0].team && allUser[boss0].team == team.key) && (allUser[boss1].team && allUser[boss1].team !== team.key)){
            //         //                         email = boss0
            //         //                     }else if(allUser[boss1].boss == arrManager[Object.keys(arrManager)[0]] && (allUser[boss1].team && allUser[boss1].team == team.key) && (allUser[boss0].team && allUser[boss0].team !== team.key)){
            //         //                         email = boss1
            //         //                     }else{
            //         //                         email = 'multiple'
            //         //                     }
            //         //                 }else{
            //         //                     email = 'multiple'
            //         //                 }
            //         //             }
            //         //         }
            //         //         if (email == 'multiple'){
            //         //             team.multiple = true
            //         //         }else if(email && allUser[email]){
            //         //             team.boss_firstname = allUser[email].firstname
            //         //             team.boss_lastname = allUser[email].lastname
            //         //             if(allUser[email].profilepic_small){
            //         //                 team.pic = allUser[email].profilepic_small;
            //         //             }else if (allUser[email].profilepic_crop){
            //         //                 team.pic = allUser[email].profilepic_crop;
            //         //             }else if (allUser[email].profilepic){
            //         //                 team.pic = allUser[email].profilepic;
            //         //             }else {
            //         //                 team.pic = '';
            //         //             }
            //         //         }else{
            //         //             team.boss_firstname = ''
            //         //             team.boss_lastname = ''
            //         //             team.pic = ''
            //         //         }
            //         //     }else{
            //         //         team.boss_firstname = ''
            //         //         team.boss_lastname = ''
            //         //         team.pic = ''
            //         //     }
            //         // }
                    
            //         // const boss = _.filter(allBoss, { 'team': team.key })
            //         // if(boss.length > 0){
            //         //     let email = ""
            //         //     if(boss.length == 1){
            //         //         email = boss[0].email.replace(/\./g, "||")
            //         //     }else{
            //         //         let boss0 = ''
            //         //         let boss1 = ''
            //         //         if(boss.length == 2){
            //         //             boss0 = boss[0].email.replace(/\./g, "||")
            //         //             boss1 = boss[1].email.replace(/\./g, "||")
            //         //         }
            //         //         if(boss.length == 2 && ((allUser[boss0] && allUser[boss0].boss && allUser[boss0].boss == boss[1].email) || (allUser[boss1] && allUser[boss1].boss && allUser[boss1].boss == boss[0].email))){
            //         //             if(allUser[boss0].boss == boss[1].email){
            //         //                 email = boss1
            //         //             }else if(allUser[boss1].boss == boss[0].email){
            //         //                 email = boss0
            //         //             }
            //         //         }else{
            //         //             let checkBigBoss = false
            //         //             let arrManager:Array<any> = [];
            //         //             for(const i in boss){
            //         //                 let mailBoss = boss[i].email.replace(/\./g, "||")
            //         //                 if(!allUser[mailBoss].boss){
            //         //                     email = mailBoss.replace(/\./g, "||")
            //         //                     checkBigBoss = true
            //         //                 }else{
            //         //                     arrManager.push({email:allUser[mailBoss].boss})
            //         //                 }
            //         //             }
            //         //             if(!checkBigBoss){
            //         //                 const checkCountManager = _.filter(arrManager, { 'email': arrManager[0].email })
            //         //                 if(arrManager.length == checkCountManager.length){
            //         //                     email = arrManager[0].email.replace(/\./g, "||")
            //         //                 }else{
            //         //                     const bossParent = _.filter(allBoss, { 'team': team.parent })
            //         //                     if(bossParent.length > 0){
            //         //                         email = bossParent[0].email.replace(/\./g, "||")
            //         //                     }
            //         //                 }
            //         //             }
            //         //         }
            //         //     }
            //         //     if(email && allUser[email]){
            //         //         team.boss_firstname = allUser[email].firstname
            //         //         team.boss_lastname = allUser[email].lastname

            //         //         if(allUser[email].profilepic_small){
            //         //             team.pic = allUser[email].profilepic_small;
            //         //         }else if (allUser[email].profilepic_crop){
            //         //             team.pic = allUser[email].profilepic_crop;
            //         //         }else if (allUser[email].profilepic){
            //         //             team.pic = allUser[email].profilepic;
            //         //         }else {
            //         //             team.pic = '';
            //         //         }
            //         //     }else{
            //         //         team.boss_firstname = ''
            //         //         team.boss_lastname = ''
            //         //         team.pic = ''
            //         //     }
                        
            //         // }else{
            //         //     if(team.sup.length > 0){
            //         //         let email = ""
            //         //         if(team.sup.length == 1){
            //         //             email = team.sup[0].email.replace(/\./g, "||")
            //         //         }else {
            //         //             let checkInMultipleTeam: any = _.filter(team.sup, { 'team': team.key })
            //         //             if(checkInMultipleTeam.length == 1){
            //         //                 email = checkInMultipleTeam[0].email.replace(/\./g, "||")
            //         //             }else{
            //         //                 let arrManager:Array<any> = [];
            //         //                 for(const i in team.sup){
            //         //                     let mailBoss = team.sup[i].email.replace(/\./g, "||")
            //         //                     if(allUser[mailBoss].boss){
            //         //                         arrManager.push({email:allUser[mailBoss].boss})
            //         //                     }
            //         //                 }
            //         //                 if(arrManager[0]){
            //         //                     const checkCountManager = _.filter(arrManager, { 'email': arrManager[0].email })
            //         //                     if(arrManager.length == checkCountManager.length){
            //         //                         email = arrManager[0].email.replace(/\./g, "||")
            //         //                     }else{
            //         //                         const bossParent = _.filter(allBoss, { 'team': team.parent })
            //         //                         if(bossParent.length > 0){
            //         //                             if(bossParent.length == 1){
            //         //                                 email = bossParent[0].email.replace(/\./g, "||")
            //         //                             }else{
            //         //                                 let checkBigBoss2 = false
            //         //                                 let arrManager2:Array<any> = [];
            //         //                                 for(const i in bossParent){
            //         //                                     let mailBoss = bossParent[i].email.replace(/\./g, "||")
            //         //                                     if(!allUser[mailBoss].boss){
            //         //                                         email = mailBoss.replace(/\./g, "||")
            //         //                                         checkBigBoss2 = true
            //         //                                     }else{
            //         //                                         arrManager2.push({email:allUser[mailBoss].boss})
            //         //                                     }
            //         //                                 }
            //         //                                 if(!checkBigBoss2){
            //         //                                     const checkCountManager2 = _.filter(arrManager2, { 'email': arrManager2[0].email })
            //         //                                     if(arrManager2.length == checkCountManager2.length){
            //         //                                         email = arrManager2[0].email.replace(/\./g, "||")
            //         //                                     }else{
            //         //                                         email = bossParent[0].email.replace(/\./g, "||")
            //         //                                     }
            //         //                                 }
            //         //                             }
            //         //                         }
            //         //                     }
            //         //                 }
            //         //             }
                                
            //         //         }
            //         //         if(email && allUser[email]){
            //         //             team.boss_firstname = allUser[email].firstname
            //         //             team.boss_lastname = allUser[email].lastname
            //         //             if(allUser[email].profilepic_small){
            //         //                 team.pic = allUser[email].profilepic_small;
            //         //             }else if (allUser[email].profilepic_crop){
            //         //                 team.pic = allUser[email].profilepic_crop;
            //         //             }else if (allUser[email].profilepic){
            //         //                 team.pic = allUser[email].profilepic;
            //         //             }else {
            //         //                 team.pic = '';
            //         //             }
            //         //         }else{
            //         //             team.boss_firstname = ''
            //         //             team.boss_lastname = ''
            //         //             team.pic = ''
            //         //         }
            //         //     }else{
            //         //         team.boss_firstname = ''
            //         //         team.boss_lastname = ''
            //         //         team.pic = ''
            //         //     }
            //         // }
            //         teams.push(team)
            //         if(doc.key) parent[doc.key] = doc.val()
            //     });
            //     _.forEach(teams, (value,key)=> {
            //         if(value.parent && parent[value.parent]){
            //             teams[key].parent_name = parent[value.parent].name
            //             if(parent[value.parent].color){
            //                 teams[key].parent_color = parent[value.parent].color
            //             }else{
            //                 teams[key].parent_color = ''
            //             }
            //         }else{
            //             teams[key].parent_name = ''
            //             teams[key].parent_color = ''
            //         }
            //     });
            //     var _teams = _.sortBy(teams, [function(o:any) { return o.duporder; }, function(o:any) { return o.name; }])
            //     commit('setResults',_teams.length)
            //     commit('setTeamDuplicate',team_duplicate)
            //     commit('setTeams', _teams.slice(0, state.size_page))
            //     commit('setTeamsAll', _teams)
            //     commit('setLoadingTeamsTable',false)
            //     if(state.inputSearch){
            //         dispatch('searchTeams',state.inputSearch)
            //     }
            // }).catch(error => {
            //     console.log(error)
            // });
        },
        async updateTeam({commit,rootState,dispatch}:any,form:any){
            // TODO: Add team_goals field to database update
            // goals: form.team_goals || '',
            await dispatch('main/addAndUpdateGoalTeam',{teamId:form.id,goals:(form.team_goals)?form.team_goals : ''}, {root:true});
            firebase.database().ref(`/team/${form.id}`).update({
                name:form.team_name,
                color:(form.color)?form.color:'',
                goals: (form.team_goals)?form.team_goals : '',
                updated:format(new Date(), 'YYYY-MM-DD HH:mm')
            }).then(()=>{
                firebase.database().ref(`/genorganize`).push({
                    company:rootState.authen.user.company
                });
                /*save logs*/
                dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: form.id,
                    table: 'team',
                    status: 'edit',
                    user: rootState.authen.user.email
                }, {root:true}).then(function() {
                    dispatch('getTeams',rootState.authen.user)
                });
            });
        },
        async createTeam({commit,rootState,dispatch}:any,form:any){
            // TODO: Add team_goals field to database creation
            // goals: form.team_goals || '',
            const newId = firebase.database().ref('team').push().key;
            await dispatch('main/addAndUpdateGoalTeam',{teamId:newId,goals:(form.team_goals)?form.team_goals : '',}, {root:true});
            firebase.database().ref(`team/${newId}`).update({
                name:form.team_name,
                color:(form.color)?form.color:'',
                goals: (form.team_goals)?form.team_goals : '',
                parent:'',
                company:rootState.authen.user.company,
                internal_id: form.internal_id,
                updated:format(new Date(), 'YYYY-MM-DD HH:mm')
            }).then(()=>{
                firebase.database().ref(`/genorganize`).push({
                    company:rootState.authen.user.company
                });
                /*save logs*/
                dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: newId,
                    table: 'team',
                    status: 'add',
                    user: rootState.authen.user.email
                }, {root:true}).then(function() {
                    dispatch('getTeams',rootState.authen.user)
                });
            });
        },
        deleteTeam({commit,rootState,dispatch}:any,key:any){
            firebase.database().ref(`/team/${key}`).remove().then(()=>{
                dispatch('getTeams',rootState.authen.user)
            }).then(()=>{
                firebase.database().ref(`/genorganize`).push({
                    company:rootState.authen.user.company
                });
                /*save logs*/
                dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: key,
                    table: 'team',
                    status: 'remove',
                    user: rootState.authen.user.email
                }, {root:true}).then(function() {
                    dispatch('getTeams',rootState.authen.user)
                });
            });
        },
        currentChange({commit,state}:any,page:any){
            var size = state.size_page
            var start_row = (page-1) * size
            var end_row = ((page-1) * size)+size
            let team: Array<any> = [];
            
            if(state.inputSearch){
                var re = new RegExp(state.inputSearch, 'gi')
                var response = _.filter(state.teamsall, (item):any => {
                    if (item.name.match(re)){
                        return true
                    }else if(item.parent_name!=undefined && item.parent_name.match(re)){
                        return true
                    }
                });
                team = response
            }else{
                team = state.teamsall
            }

            if (state.sortBy == 'name') {
                team = _.sortBy(team, [function(o:any) { return o.name; }])
            }else if (state.sortBy == 'parent') {
                team = _.sortBy(team, [function(o:any) { return o.parent_name; }])
            }
            commit('setPage',page)
            commit('setTeams', team.slice(start_row,end_row))
        },
        searchTeams({commit,state}:any,value:string){
            commit('setPage',1)
            let response: Array<any> = [];
            var re = new RegExp(value, 'gi')
            response = _.filter(state.teamsall, (item):any => {
                if (item.name.match(re)){
                    return true
                }else if(item.parent_name!=undefined && item.parent_name.match(re)){
                    return true
                }
            });
            if (state.sortBy == 'name') {
                response = _.sortBy(response, [function(o:any) { return o.duporder; },function(o:any) { return o.name; }])
            }else if (state.sortBy == 'parent') {
                response = _.sortBy(response, [function(o:any) { return o.duporder; },function(o:any) { return o.parent_name; }])
            }
            commit('setResults', response.length)
            commit('setTeams',response.slice(0,state.size_page))
        },
        sortBy({ commit, state }: any, type: string) {
            commit('setPage',1)
            state.sortBy = type
            let team: Array<any> = [];
            if(state.inputSearch){
                var re = new RegExp(state.inputSearch, 'gi')
                var response = _.filter(state.teamsall, (item):any => {
                    if (item.name.match(re)){
                        return true
                    }else if(item.parent_name!=undefined && item.parent_name.match(re)){
                        return true
                    }
                });
                team = response
            }else{
                team = state.teamsall
            }
            if (type == 'name') {
                team = _.sortBy(team, [function(o:any) { return o.duporder; },function(o:any) { return o.name; }])
            }else if (type == 'parent') {
                team = _.sortBy(team, [function(o:any) { return o.duporder; },function(o:any) { return o.parent_name; }])
            }    
            commit('setTeams',team.slice(0,state.size_page))
        },
    },
    getters: {
        teamsall: (state:any) => {
            return state.teamsall
        },
        teams : (state:any) => {
            return state.teams
        },
        inputSearch: (state:any) => {
            return state.inputSearch
        },
        results : (state:any) => {
            return state.results
        },
        page : (state:any) => {
            return state.page
        },
        teamDuplicate : (state:any) => {
            return state.teamDuplicate
        },
        organizations : (state:any) => {
            return state.organizations
        },
        loadingTeamsTable : (state:any) => {
            return state.loadingTeamsTable
        },
        teamRandomNumber : (state:any) => {
            return state.teamRandomNumber
        },
    }
  }